
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getWebSiteName ,getAdmissionsProfile,getWebSiteAddress} from '../../api/main'
import {getIndexConfig} from "../../api/config";
export default {
name: 'Layout',
components: {
ViewBox,
Tabbar,
TabbarItem,
Group,
Cell
},
data () {
return {
AdmissionsProfile:'',
WebSiteAddress:'',
QGJSFlag: false,
CSJSFlag: false,
bottomShowConfig: {
IS_SHOW_INDEX_OW: false,
IS_SHOW_INDEX_AI: false,
IS_SHOW_INDEX_OI: false,
IS_SHOW_INDEX_TP: false,
IS_SHOW_INDEX_AN: false
}
}
},
created(){
getWebSiteName().then(response => {
document.title = response.data + '报名平台'
window.sessionStorage.setItem('websiteName', response.data)
if(response.data.indexOf("城市建设") > -1){
console.log('wdddiioo')
this.bottomShowConfig.IS_SHOW_INDEX_AN = false
this.CSJSFlag = true
}
if(response.data.indexOf("轻工技师") > -1){
console.log('aaa')
this.QGJSFlag = true
}
})
getAdmissionsProfile().then(response => {
this.AdmissionsProfile= response.data
})
getWebSiteAddress().then(response => {
this.WebSiteAddress = response.data
})
this.getIndexConfig()
},
methods: {
handleShare() {
this.$router.push({ path: '/login' })
},
chatQQ(){
this.$router.push({ path: '/contactOnline' })
},
admissionInfo(){

if(this.QGJSFlag || this.CSJSFlag){
window.location.href = process.env.BASE_API + '/notice/'+'rxxz.jpg'
}else{
this.$router.push({ path: '/admissionInfo' })
}



},
getIndexConfig(){
getIndexConfig().then(res => {
this.bottomShowConfig = res.data
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/layout/Layout.vue